<template>
  <div className="container">
    <div
      id="correctionAutoComplete"
      :data-testid="`${datatestId}`"
      @input="onKeyPress($event.target.value)"
    />
  </div>
</template>

<script lang="js">
import { Fragment, render, onMounted, defineComponent } from 'vue';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import ReasonCorrectionSearchResultItem from './ReasonCorrectionSearchResultItem.vue';
import { createElement } from './adapter';

export default defineComponent({
  name: 'App',
  props: {
    algoliaIndex: {
      type: String, required: true
    },
    optionalFiltersReasonKeys: {
      type: Array, required: true
    },
    searchClient: {
      type: Object, required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    let autoComplete;

    function onSelectedItemEvent(correctionSearchResult) {
      emit('selectedItemEvent', correctionSearchResult);
      clearQuery()
    }

    function clearQuery() {
      if(autoComplete && autoComplete.setQuery) {
        autoComplete.setQuery('')
      }
    }

    function onKeyPress(value){
      emit('keyPress', value);
    }

    onMounted(() => {
      if(props.readonly) return
      props.searchClient.clearCache();
      autoComplete = autocomplete({
        onSubmit(e) {
          emit('enterPress', e.state.query);
        },
        container: '#correctionAutoComplete',
        placeholder: 'Recommendation',
        getSources({ query }) {
          return [
            {
              sourceId: 'products',
              getItems() {
                return getAlgoliaResults({
                  searchClient: props.searchClient,
                  queries: [
                    {
                      indexName: props.algoliaIndex,
                      optionalFilters: props.optionalFiltersReasonKeys,
                      query
                    }
                  ]
                });
              },
              templates: {
                item({ item, components }) {
                  return (
                    <ReasonCorrectionSearchResultItem
                      onSelectedItemEvent={onSelectedItemEvent}
                      item={item}
                      highlight={components.Highlight}
                    />
                  );
                }
              }
            }
          ];
        },
        renderer: {
          createElement,
          Fragment
        },
        render({ children }, root) {
          render(children, root);
        }
      });
    });
    return {
        onKeyPress,
      }
  }
});
</script>
